<script setup lang="ts">
import { useI18n } from 'vue-i18n'

defineProps<{
  eventName: string
  organisationName: string
}>()

const { t } = useI18n()
</script>

<template>
  <div class="bg-white border-b border-slate-200">
    <div class="max-w-2xl mx-auto px-4 sm:px-6 py-6">
      <div class="flex items-start gap-3">
        <div class="min-w-0 flex-1">
          <div class="flex items-center gap-2 mb-1">
            <span class="inline-flex items-center rounded-full bg-sky-100 px-2.5 py-0.5 text-xs font-semibold uppercase tracking-wider text-sky-700">
              {{ t('volunteer.wizard.header.pill') }}
            </span>
          </div>
          <h1 class="text-xl font-bold text-slate-900 leading-tight">
            {{ t('volunteer.wizard.header.title', { eventName }) }}
          </h1>
          <p class="text-sm text-slate-500 mt-0.5">{{ organisationName }}</p>
        </div>
      </div>
    </div>
  </div>
</template>
